import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import type { NatconArticle } from '../../Kentico/DigitalDesign/natcon_article';
import withContext from '../../ContextAPI/Context_HOC';
import NatConProxy from '../Utilities/NatConProxy';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-flexbox-grid';
import NatConCarousel2025 from './NatConCarousel2025';
import { byPinnedThenByDatePublished } from '../Utilities/NatConUtils';

const NatCon2025: FunctionComponent<{
  context: { natConProxy: NatConProxy };
}> = ({ context: { natConProxy } }) => {
  const [natconArticles, setNatconArticles] = useState([] as NatconArticle[]);
  useEffect(() => {
    const natConProxyGetNatConsSubscription = natConProxy.getNatCons('national_convention_2025').subscribe((x) => {
      const articlesSorted = [...x].sort(byPinnedThenByDatePublished);
      setNatconArticles(articlesSorted);
    });
    return () => natConProxyGetNatConsSubscription.unsubscribe();
  }, [natConProxy]);
  return (
    <div>
      <NatConCarousel2025 />
      <h1>117th US Bahá’í National Convention: April 24 – 27, 2025</h1>
      <h4>
        More photos from the Convention are available on{' '}
        <a href="https://www.flickr.com/photos/bahaius/collections/72157723720515344/" target="_blank" rel="noopener noreferrer">
          Flickr
        </a>
        .
      </h4>
      <h4>
        Below are stories on the Convention from <em>The American Bahá’í</em>
      </h4>
      <hr />
      <Row>
        <Col sm={12} md={8}>
          {natconArticles.map((article, index) => {
            const introBlurbHtml = article.introBlurb.resolveHtml();
            const intro = parse(introBlurbHtml);
            const thumbnailUrl = article.articleThumbnail?.value?.length > 0 ? article.articleThumbnail.value[0].url : null;
            const thumbnailDescription =
              article.articleThumbnail?.value?.length > 0 ? article.articleThumbnail.value[0].description : '';
            return (
              <Fragment key={index + Date.now() + article.urlSlug.value + article.system.id}>
                <Link
                  to={{ pathname: `/news/natcon-2025/${article.system.codename}` }}
                  className="plain-link plain-hover"
                  key={index}
                  data-testid={`natconarticle${index}`}
                >
                  <Row>
                    <Col sm={3}>
                      {thumbnailUrl ? <img src={thumbnailUrl} alt={thumbnailDescription} className="thumbnail-img" /> : null}
                    </Col>
                    <Col sm={9}>
                      <h3>{article.baseTitle.value}</h3>
                      <div>{intro}</div>
                    </Col>
                  </Row>
                </Link>
                <hr />
              </Fragment>
            );
          })}
        </Col>
        <Col sm={12} md={4}>
          <div className="sidebar-box">
            <h4>Resources</h4>
            <ul>
              <li className="small-bottom-padding">
                <Link to="/nine-year-plan">Nine Year Plan documents</Link>
              </li>
              <li className="small-bottom-padding">
                <Link to="/guidance/uhj/ridvan-2025-message-from-the-supreme-body-2025/ridvan-2025-message-from-the-supreme-body-2025">
                  Ridván 2025 Message from the Supreme Body
                </Link>
              </li>
              <li className="small-bottom-padding">
                <a href="https://bahai-web.s3.us-east-1.amazonaws.com/messages/AnnualReports/Ridvan+Annual+Report+2025.pdf">
                  Ridván 2025 Annual Report
                </a>
              </li>
            </ul>
            <hr />
            <h4>Secretary’s Report</h4>
            <iframe
              title="Secretary’s Report"
              src="https://player.vimeo.com/video/1078804386?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              width="100%"
              height="166"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
            <hr />
            <h4>Treasurer’s Report</h4>
            <iframe
              title="Treasurer’s Report"
              src="https://player.vimeo.com/video/1078827311?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              width="100%"
              height="166"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
            <hr />
            <h4>Accompaniment</h4>
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652437%3Fsecret_token%3Ds-VGZL8u7L2Dw&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652479%3Fsecret_token%3Ds-cgbdG22wCs3&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652440%3Fsecret_token%3Ds-kn29YH45zHl&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <h4>Advanving Clusters</h4>
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652485%3Fsecret_token%3Ds-jwk8kBpBSZd&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652473%3Fsecret_token%3Ds-qTtpwv2Yuyq&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652434%3Fsecret_token%3Ds-mjf6lp4uSIh&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652455%3Fsecret_token%3Ds-sotiCREwVcb&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652431%3Fsecret_token%3Ds-uLiGdWgdrjk&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652482%3Fsecret_token%3Ds-NNaQX1IjnlN&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <h4>Natural Disaster Response</h4>
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652443%3Fsecret_token%3Ds-RKyWWDUUGuW&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652449%3Fsecret_token%3Ds-wWstof0SWru&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <h4>Race Unity - Overcoming Prejudices</h4>
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652464%3Fsecret_token%3Ds-c6dku8O7l59&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652452%3Fsecret_token%3Ds-PZ27xjHYIcr&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652476%3Fsecret_token%3Ds-uWZA27kuf4B&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652461%3Fsecret_token%3Ds-9MvJQFvQTbu&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <h4>Youth - JY Initiatives</h4>
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652467%3Fsecret_token%3Ds-drpV4z3mj4U&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652494%3Fsecret_token%3Ds-IihPjv50KsL&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652458%3Fsecret_token%3Ds-kt0f574WPyI&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652446%3Fsecret_token%3Ds-Umh9pyi6s8E&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652488%3Fsecret_token%3Ds-LPhcsNVKqG1&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652470%3Fsecret_token%3Ds-QTUvmm3OnAK&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <iframe
              width="100%"
              height="20"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2091652491%3Fsecret_token%3Ds-hwz71kXcMlg&color=%230066cc&inverse=false&auto_play=false&show_user=false"
            />
            <p>These audio excerpts are only playable on this page. They are not available to download.</p>
            <hr />
            <h4>National Convention Coverage Archives</h4>
            <ul className="plain-list">
              <li>
                <Link to="/news/natcon-2024">National Convention 2024</Link>
              </li>
              <li>
                <Link to="/news/natcon-2023">National Convention 2023</Link>
              </li>
              <li>
                <Link to="/news/natcon-2022">National Convention 2022</Link>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default withContext(NatCon2025);
